module.exports = __webpack_public_path__ + "img/BS-Silo-front.fcf4311a.png";